import { render, staticRenderFns } from "./FormPrivilege.vue?vue&type=template&id=b22bbe9a&scoped=true&"
import script from "./FormPrivilege.vue?vue&type=script&lang=js&"
export * from "./FormPrivilege.vue?vue&type=script&lang=js&"
import style0 from "./FormPrivilege.vue?vue&type=style&index=0&id=b22bbe9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22bbe9a",
  null
  
)

export default component.exports